import { Route, Routes } from "react-router-dom";
import { authItemsPaths, navItemsPaths } from "./paths";
import PrivateRoute from "./privateRoute";
import PublicRoute from "./publicRoute";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUserProfile } from "../redux/reducers/authSlice";
import UserService from "../keycloak/UserService";
import HealthCheckGuard from "../components/heathCheckGuard/heathCheckGuard";

export default function AppRouter() {
  const dispatch = useDispatch();

  const getRootElement = (navItem) => {
    const isPrivatePath = navItem?.isPrivateRoute;
    let element = navItem?.element;
    if (isPrivatePath) {
      element = <PrivateRoute>{element}</PrivateRoute>;
    }
    return element;
  };
  const getAuthRootElements = (authItem) => {
    return <PublicRoute>{authItem}</PublicRoute>;
  };

  useEffect(() => {
    UserService.getToken() &&
      UserService.loadUserProfile()
        .then((profile) => {
          dispatch(setUserProfile(profile));
        })
        .catch((error) => {
          console.error("error", error);
        });
  }, [UserService]);

  return (
      <Routes>
        {UserService.isLoggedIn() &&
          navItemsPaths?.map((navItem) => (
            <Route
              path={navItem?.path}
              element={getRootElement(navItem)}
              key={navItem?.path}
            />
          ))}
        {authItemsPaths?.map((authItem) => (
          <Route
            path={authItem?.path}
            element={getAuthRootElements(authItem)}
            key={authItem?.path}
          />
        ))}
      </Routes>
  );
}
